
import { Component, Vue } from 'vue-property-decorator'
import { goToSet, goToFeedback } from '@/utils/h5ToApp'
@Component
export default class topServe extends Vue {
  goToSet() {
    goToSet()
  }

  goToFeedBack() {
    goToFeedback()
  }
}
